import * as ListAccountReport from './list';
import * as DowloadAccountReport from './excel';
const Actions = {
  ...ListAccountReport,
  ...DowloadAccountReport,
};
export default Actions;
